import React from 'react'
import { Link } from 'react-router-dom'

export default function AboutV2One() {
    return (
        <section className="ht-sec" id="about">
            <div className="ht-wrap ht-about">
                <div className="ht-about-img">
                    <img src="/assets/img/about-img-1.png" alt="Hakkında" />
                </div>
                <div className="ht-about-text">
                    <p className="ht-eyebrow">Boşta Kalan Cüzleri Tamamlayalım mı?</p>
                    <h2 className="ht-h2">Paylaşmanın Bereketine Ortak Olun</h2>
                    <p className="ht-quote">
                        "Devam eden hatimlerimizde okunmayı bekleyen cüzler var. Bir halka da siz eklemek ister misiniz?"
                    </p>
                    <Link to="/#cuz-al" className="ht-btn ht-btn-gold" aria-label="Cüz AL">
                        CÜZ AL
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" /></svg>
                    </Link>
                </div>
            </div>
        </section>
    );
}
